import { call, put, select, takeEvery } from 'redux-saga/effects';
import { types, getIntroMessagesSuccessAction } from '@actions/introMessages';
import {
  getIntroMessages,
  createIntroMessage,
  disableIntroMessage,
  uploadIntroMessageFile,
  assignIntroMessageToOrganization,
  unassignIntroMessageFromOrganization,
} from '@services/introMessagesResource';
import { tokenSelector } from '@selectors/authentication';
import { selectAudioFile } from '@selectors/introMessages';

export function* getIntroMessagesSaga(action) {
  try {
    const token = yield select(tokenSelector);
    if (!token) return false;
    const {
      data: { messages },
    } = yield call(getIntroMessages, token, action.payload);

    yield put(getIntroMessagesSuccessAction({ data: messages }));
  } catch (err) {
    yield put({
      type: types.GET_INTRO_MESSAGES.FAILURE,
      message: err.message || 'Error when fetching intro messages.',
    });
  }
}

export function* createIntroMessageSaga({ payload: { audioMessageFile, text = '' } }) {
  try {
    const token = yield select(tokenSelector);
    if (!token) return false;

    let response = {};
    if (audioMessageFile) {
      const audioFile = yield select(selectAudioFile);
      response.data = (yield call(
        uploadIntroMessageFile,
        audioFile,
        token,
      )).data.introMessage;
    }

    if (text) {
      const data = {
        text,
        isActive: true,
      };
      response = yield call(createIntroMessage, { token, data });
    }

    yield put({
      type: types.CREATE_INTRO_MESSAGE.SUCCESS,
      payload: { ...response },
    });
  } catch (err) {
    yield put({
      type: types.CREATE_INTRO_MESSAGE.FAILURE,
      message: err.message || 'Error while creating intro message.',
    });
  }
}

export function* assignIntroMessageToOrganizationSaga(action) {
  try {
    const token = yield select(tokenSelector) || action.payload.token;
    if (!token) return false;
    const response = action.payload.id
      ? yield call(assignIntroMessageToOrganization, {
          id: action.payload.id,
          organizationId: action.payload.organizationId,
          token,
        })
      : yield call(unassignIntroMessageFromOrganization, {
          token,
          organizationId: action.payload.organizationId,
        });
    yield put({
      type: types.ASSIGN_INTRO_MESSAGE_TO_ORGANIZATION.SUCCESS,
      payload: { ...response },
    });
  } catch (err) {
    yield put({
      type: types.ASSIGN_INTRO_MESSAGE_TO_ORGANIZATION.FAILURE,
      message: err.message || 'Error while creating intro message.',
    });
  }
}

export function* disableIntroMessageSaga(action) {
  try {
    const token = yield select(tokenSelector);
    if (!token) return false;
    const { id } = action.payload;
    const confirmation = window.confirm(
      'Do you really want to disable this intro message?',
    );
    if (confirmation !== true) {
      return;
    }
    yield call(disableIntroMessage, { token, id });

    yield put({
      type: types.DISABLE_INTRO_MESSAGE.SUCCESS,
    });

    yield put({
      type: types.GET_INTRO_MESSAGES.REQUEST,
      payload: {
        include: 'organization',
      },
    });
  } catch (err) {
    yield put({
      type: types.DISABLE_INTRO_MESSAGE.FAILURE,
      message: err.message || 'Error when disabling the message.',
    });
  }
}

export default function*() {
  yield takeEvery(types.CREATE_INTRO_MESSAGE.REQUEST, createIntroMessageSaga);
  yield takeEvery(types.DISABLE_INTRO_MESSAGE.REQUEST, disableIntroMessageSaga);
  yield takeEvery(types.GET_INTRO_MESSAGES.REQUEST, getIntroMessagesSaga);
  yield takeEvery(
    types.ASSIGN_INTRO_MESSAGE_TO_ORGANIZATION.REQUEST,
    assignIntroMessageToOrganizationSaga,
  );
}



// WEBPACK FOOTER //
// ./redux/sagas/introMessages.js